import React from 'react';
import styled from 'styled-components';
import { IconAlertTriangle } from 'TimeOffList/components/icons';
import type { OverlapDetail } from '../services/staged-records';

interface Props {
  conflicts: OverlapDetail[];
}

/** Non-blocking amber warning listing overlaps with existing time off. */
const ConflictWarning: React.FC<Props> = ({ conflicts }) => {
  if (!conflicts.length) return null;
  const title = conflicts.length === 1 ? 'Overlaps existing time off' : `${conflicts.length} overlaps with existing time off`;
  return (
    <Card>
      <TitleRow>
        <IconAlertTriangle size={17} strokeWidth={2.2} color="#B45309" />
        <span className="title">{title}</span>
      </TitleRow>
      <Lines>
        {conflicts.map((c, i) => <span key={i}>{c.label}</span>)}
      </Lines>
    </Card>
  );
};

export default ConflictWarning;

const Card = styled.div`
  border: 1px solid #F2D48A;
  background: var(--warning-100);
  border-radius: var(--r-lg);
  padding: 12px 14px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  svg { flex-shrink: 0; }
  .title { font-size: 13px; font-weight: 700; color: #92400E; }
`;

const Lines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding-left: 25px;
  span { font-size: 12px; color: #92400E; }
`;
